import type { Dayjs } from 'dayjs'

// Mirror of Host.Data.Constants.WorkspaceRetention.PERMANENT_DELETION_DAYS.
// Retention tracking only — nothing is deleted on this date (ZCR-2571 / merged ZCR-2344).
export const PERMANENT_DELETION_DAYS = 365

export function permanentDeletionDate(inactiveDate: Dayjs | null | undefined): Dayjs | null {
  if (!inactiveDate || !inactiveDate.isValid()) return null
  return inactiveDate.add(PERMANENT_DELETION_DAYS, 'day')
}

export function formatPermanentDeletionDate(inactiveDate: Dayjs | null | undefined): string {
  return permanentDeletionDate(inactiveDate)?.format('YYYY-MM-DD') ?? ''
}
